<template>
  <div class="access-token">
    <div class="card">
      <div class="card-header">
        <h3>Tokens de Acesso</h3>
      </div>
      <div class="card-body">
        <ErrorAlert :error="error" :centered="true" />
        <div class="row">
          <div class="col-sm-12 col-md-6 d-flex">
            <div class="input-group">
              <div class="input-group-prepend">
                <button
                  disabled
                  class="input-group-text">por página</button>
              </div>
              <select
                class="custom-select custom-select-sm form-control form-control-sm perPage"
                id="perPage"
                v-model="perPage">
                <option
                  v-for="option in pageOptions"
                  :key="option"
                  :value="option">
                  {{ option }}
                </option>
              </select>
            </div>
            <div class="ml-auto">
              <a
                href="#"
                class="btn btn-primary"
                @click.prevent="showTokenModal">Novo Token de Acesso</a>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="input-group filter ml-auto">
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Buscar por"
                aria-label="Buscar por"
                v-model="filter">
              <div class="input-group-append">
                <button
                  :disabled="!filter"
                  @click="filter = ''"
                  class="input-group-text">Limpar</button>
              </div>
            </div>
          </div>
        </div>
        <div class="card-table text-left">
          <b-table
            class="table"
            show-empty
            striped
            hover
            small
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered">

            <template
              slot="id"
              slot-scope="row">
              <span>
                <a
                  class="dropdown-item"
                  href="#"
                  :data-clipboard-text="row.item.id"
                  @click.prevent="copyToClipboard">{{ row.item.id }}</a>
              </span>
            </template>

            <template
              slot="created"
              slot-scope="row">
              <span>{{ parseDate(row.item.created) }}</span>
            </template>

            <template
              slot="expiresOn"
              slot-scope="row">
              <span>{{ calculateTTL(row.item.ttl, row.item.created) }}</span>
            </template>

            <template
              slot="details"
              slot-scope="row">
              <button
                class="btn btn-danger btn-sm"
                @click="showConfirmDelete(row)">Remover</button>
            </template>
          </b-table>
        </div>
        <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          :limit="10" />
      </div>
    </div>

    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="newTokenModal"
      ref="newTokenModal"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Novo token expira em</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <select
                  class="form-control custom-select custom-select-sm"
                  v-model="newTokenTTL">
                  <option
                    v-for="option in ttlOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Cancelar</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="createNewToken">Criar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Você tem certeza?</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger"
              role="alert">
              Você tem certeza que deseja remover este token?
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteToken">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'

export default {
  name: 'AccessToken',
  data () {
    return {
      error: null,
      perPage: 10,
      pageOptions: [10, 25, 50],
      currentPage: 1,
      totalRows: 1,
      filter: null,
      newTokenTTL: '86400',
      tokenToDelete: null,
      fields: {
        id: {
          label: 'Token',
          sortable: false
        },
        created: {
          label: 'Criado em',
          sortable: true
        },
        expiresOn: {
          label: 'Expira em',
          sortable: true
        },
        details: {
          label: 'Ações',
          sortable: false,
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      },
      items: null,
      ttlOptions: [
        { value: 86400, text: '24h' },
        { value: 604800, text: '1 semana' },
        { value: 1209600, text: '2 semanas' },
        { value: 2592000, text: '1 mês' },
        { value: 31536000, text: '1 ano' },
        { value: -1, text: 'Nunca expira' }
      ]
    }
  },
  mounted () {
    this.getTokens()
  },
  methods: {
    getTokens () {
      this.error = null
      loopback
        .get(`/users/accessTokens?filter[order]=created desc`)
        .then(tokens => {
          if (tokens) {
            this.items = tokens
            this.totalRows = this.items.length
          }
        })
        .catch((err) => {
          this.error = err
        })
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    parseDate (date) {
      if (date) return new Date(date).toLocaleString()
      return ''
    },
    showConfirmDelete (row) {
      if (row.item) {
        this.tokenToDelete = row.item.id
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    showTokenModal () {
      $(this.$refs.newTokenModal).modal('show')
    },
    deleteToken () {
      this.error = null
      $(this.$refs.confirmDelete).modal('hide')
      const tokenToDeleteDup = this.tokenToDelete
      loopback
        .delete(`/users/accessTokens/${tokenToDeleteDup}`)
        .then(deleteCount => {
          this.items = this.items.filter(function (ele) {
            return ele.id !== tokenToDeleteDup
          })
          this.totalRows = this.items.length
        })
        .catch((err) => {
          this.error = err
        })
    },
    calculateTTL (ttl, created) {
      if (ttl === -1) {
        return 'Não expira'
      } else {
        const createdOn = new Date(created)
        createdOn.setSeconds(createdOn.getSeconds() + parseInt(ttl))
        return this.parseDate(createdOn)
      }
    },
    createNewToken () {
      this.error = null
      loopback
        .post(`/users/accessTokens`, {
          ttl: this.newTokenTTL
        })
        .then(newToken => {
          if (newToken && newToken.id) {
            this.items.push(newToken)
            this.totalRows = this.items.length
          }
        })
        .finally(_ => {
          $(this.$refs.newTokenModal).modal('hide')
        })
        .catch((err) => {
          this.error = err
        })
    },
    copyToClipboard (event) {
      navigator.clipboard.writeText(event.target.dataset.clipboardText).then(_ => {
        console.log('api4com > copying to clipboard was successful')
      }, err => {
        console.error('api4com > error to copy text:', err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/User/AccessToken.vue